export default "__VITE_ASSET__12d09f8b__"